var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrossIconRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9375 4.09817C12.6876 0.856274 7.35436 0.856274 4.10443 4.09817C0.854512 7.34006 0.854512 12.6601 4.10443 15.902C7.35436 19.1439 12.6042 19.1439 15.8542 15.902C19.1041 12.6601 19.1874 7.34006 15.9375 4.09817ZM12.3542 13.4914L10.021 11.1638L7.68768 13.4914L6.52104 12.3276L8.85432 10.0001L6.52104 7.67257L7.68768 6.50881L10.021 8.83632L12.3542 6.50881L13.5209 7.67257L11.1876 10.0001L13.5209 12.3276L12.3542 13.4914Z",
    fill: "#F44621"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossIconRed);
export default __webpack_public_path__ + "static/media/cross-icon-red.f691a0a4a99fe39e1d5ffa1ac212dcc6.svg";
export { ForwardRef as ReactComponent };